<template>
  <div class="container max-w-full mx-auto md:py-4 px-6 text-gray-800">
    <div class="max-w-xl mx-auto">
      <div class="relative">
        <div class="flex flex-wrap">
          <div class="mt-6">
            <h1 class="text-4xl mb-1 font-bold">Nova Senha</h1>
          </div>
        </div>
        <form action class="mt-6" @submit.prevent="doRecover">
          <input-icon
            :icon="{ name: 'lock', type: 'regular' }"
            id="password"
            name="password"
            v-model="password"
            type="password"
            label="Senha:"
          ></input-icon>
          <input-icon
            :icon="{ name: 'lock', type: 'solid' }"
            id="password_confirmation"
            name="password_confirmation"
            v-model="password_confirmation"
            type="password"
            label="Confirme a nova senha:"
          ></input-icon>
          <div class="flex flex-col ">
            <button-icon
              text="Recuperar minha senha"
              type="submit"
              icon="right-arrow-alt"
              class="lg:flex-1 bg-primary hover:bg-indigo-400 mb-1 mt-7"
            ></button-icon>
            <div class="align-middle mt-6 ">
              <box-icon name='arrow-back' class="fill-current p-1"></box-icon>
              <router-link to="/auth/login" class="align-middle">
                Voltar para tela de login
              </router-link>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      password: null,
      password_confirmation: null
    }
  },
  methods: {
    doRecover () {
      const data = {
        email: this.$route.params.email,
        token: this.$route.params.token,
        password: this.password,
        password_confirmation: this.password_confirmation
      }
      this.$store.dispatch('NEW_PASSWORD', data)
        .then((response) => {
          this.$toasted.success(response.data.message, {
            position: 'top-center',
            duration: 5000,
            icon: 'check'
          })
          this.$router.push({ name: 'login' })
        })
        .catch((error) => {
          if (error.status === 400) {
            this.$toasted.error(error.data.message, {
              position: 'top-center',
              duration: 5000,
              icon: 'close'
            })
          }
        })
    }
  }
}
</script>

<style>

</style>
